export class DefaultConstant {
  public static defaultPreferenceArr = [
    {
      prefSeqId: 104,
      colName: 'Closed',
      name: 'last_updated',
      colIndex: 0,
      hidden: false,
      width: 120,
    },
    {
      prefSeqId: 104,
      colName: 'ID',
      name: 'event_id',
      colIndex: 1,
      hidden: true,
      width: 60,
    },
    {
      prefSeqId: 104,
      colName: 'Type',
      name: 'event_type',
      colIndex: 2,
      hidden: false,
      width: 60,
    },
    {
      prefSeqId: 104,
      colName: 'Problem Type',
      name: 'problem_type',
      colIndex: 3,
      hidden: false,
      width: 100,
    },
    {
      prefSeqId: 104,
      colName: 'Route',
      name: 'puroute',
      colIndex: 4,
      hidden: false,
      width: 60,
    },
    {
      prefSeqId: 104,
      colName: 'U/L',
      name: 'arrival',
      colIndex: 5,
      hidden: false,
      width: 80,
    },
    {
      prefSeqId: 104,
      colName: 'Route Group',
      name: 'route',
      colIndex: 6,
      hidden: true,
      width: 60,
    },
    {
      prefSeqId: 104,
      colName: 'Run',
      name: 'run',
      colIndex: 7,
      hidden: true,
      width: 60,
    },
    {
      prefSeqId: 104,
      colName: 'Region',
      name: 'region',
      colIndex: 8,
      hidden: false,
      width: 60,
    },
    {
      prefSeqId: 104,
      colName: 'Status ID',
      name: 'status_id',
      colIndex: 9,
      hidden: true,
      width: 60,
    },
    {
      prefSeqId: 104,
      colName: 'Status',
      name: 'status',
      colIndex: 10,
      hidden: true,
      width: 60,
    },
    {
      prefSeqId: 104,
      colName: 'Problem Type ID',
      name: 'problem_type_id',
      colIndex: 11,
      hidden: true,
      width: 60,
    },
    {
      prefSeqId: 104,
      colName: 'LP ID',
      name: 'transportation_provider_id',
      colIndex: 12,
      hidden: true,
      width: 60,
    },
    {
      prefSeqId: 104,
      colName: 'LP',
      name: 'transportation_provider',
      colIndex: 13,
      hidden: true,
      width: 60,
    },
    {
      prefSeqId: 104,
      colName: 'Trailer',
      name: 'eventTrailer',
      colIndex: 14,
      hidden: false,
      width: 60,
    },
    {
      prefSeqId: 104,
      colName: 'ETA',
      name: 'eta',
      colIndex: 15,
      hidden: true,
      width: 60,
    },
    {
      prefSeqId: 104,
      colName: 'Last Updated By',
      name: 'last_updated_by',
      colIndex: 16,
      hidden: true,
      width: 60,
    },
    {
      prefSeqId: 104,
      colName: 'AB',
      name: 'ab',
      colIndex: 17,
      hidden: false,
      width: 20,
    },
    {
      prefSeqId: 104,
      colName: 'AL',
      name: 'al',
      colIndex: 18,
      hidden: false,
      width: 20,
    },
    {
      prefSeqId: 104,
      colName: 'BC',
      name: 'bc',
      colIndex: 19,
      hidden: false,
      width: 20,
    },
    {
      prefSeqId: 104,
      colName: 'C',
      name: 'c',
      colIndex: 20,
      hidden: false,
      width: 20,
    },
    {
      prefSeqId: 104,
      colName: 'E',
      name: 'e',
      colIndex: 21,
      hidden: false,
      width: 20,
    },
    {
      prefSeqId: 104,
      colName: 'G',
      name: 'g',
      colIndex: 22,
      hidden: false,
      width: 20,
    },
    {
      prefSeqId: 104,
      colName: 'I',
      name: 'i',
      colIndex: 23,
      hidden: false,
      width: 20,
    },
    {
      prefSeqId: 104,
      colName: 'K',
      name: 'k',
      colIndex: 24,
      hidden: false,
      width: 20,
    },
    {
      prefSeqId: 104,
      colName: 'MS',
      name: 'ms',
      colIndex: 25,
      hidden: false,
      width: 20,
    },
    {
      prefSeqId: 104,
      colName: 'MT',
      name: 'mt',
      colIndex: 26,
      hidden: false,
      width: 20,
    },
    {
      prefSeqId: 104,
      colName: 'TX',
      name: 'tx',
      colIndex: 27,
      hidden: false,
      width: 20,
    },
    {
      prefSeqId: 104,
      colName: 'U',
      name: 'u',
      colIndex: 28,
      hidden: false,
      width: 20,
    },
    {
      prefSeqId: 104,
      colName: 'WV',
      name: 'wv',
      colIndex: 29,
      hidden: false,
      width: 20,
    },
    {
      prefSeqId: 104,
      colName: 'Next Connection',
      name: 'next_connection',
      colIndex: 30,
      hidden: true,
      width: 60,
    },
    {
      prefSeqId: 104,
      colName: 'Expedites',
      name: 'expedites',
      colIndex: 31,
      hidden: false,
      width: 80,
    },
    {
      prefSeqId: 104,
      colName: 'Pull Aheads',
      name: 'pull_aheads',
      colIndex: 32,
      hidden: false,
      width: 70,
    },
    {
      prefSeqId: 104,
      colName: 'Tail Loads',
      name: 'tail_loads',
      colIndex: 33,
      hidden: false,
      width: 70,
    },
    {
      prefSeqId: 104,
      colName: 'Others',
      name: 'others',
      colIndex: 34,
      hidden: false,
      width: 70,
    },
    {
      prefSeqId: 104,
      colName: 'Comments',
      name: 'comments',
      colIndex: 35,
      hidden: false,
      width: 150,
    },
    {
      prefSeqId: 104,
      colName: 'Action',
      name: 'action',
      colIndex: 36,
      hidden: false,
      width: 100,
    },
  ];
  public static defaultDashboardPreferenceArr = [
    {
      prefSeqId: 181,
      colName: 'ROUTE TYPE',
      name: 'route_type',
      colIndex: 13,
      hidden: true,
      width: 60,
    },
    {
      prefSeqId: 181,
      colName: 'COMMENTS',
      name: 'comments',
      colIndex: 12,
      hidden: false,
      width: 60,
    },
    {
      prefSeqId: 181,
      colName: 'REGION',
      name: 'region',
      colIndex: 1,
      hidden: false,
      width: 60,
    },
    {
      prefSeqId: 181,
      colName: 'LP',
      name: 'transportation_provider',
      colIndex: 2,
      hidden: false,
      width: 60,
    },
    {
      prefSeqId: 181,
      colName: 'EVENT',
      name: 'event_type',
      colIndex: 3,
      hidden: false,
      width: 60,
    },
    {
      prefSeqId: 181,
      colName: 'PROBLEM',
      name: 'problem_type',
      colIndex: 4,
      hidden: false,
      width: 60,
    },
    {
      prefSeqId: 181,
      colName: 'TRAILER',
      name: 'event_trailer',
      colIndex: 5,
      hidden: false,
      width: 60,
    },
    {
      prefSeqId: 181,
      colName: 'ORDER #',
      name: 'order_number',
      colIndex: 6,
      hidden: false,
      width: 60,
    },
    {
      prefSeqId: 181,
      colName: 'BORDER CROSSING',
      name: 'border_crossing',
      colIndex: 7,
      hidden: false,
      width: 60,
    },
    {
      prefSeqId: 181,
      colName: 'PART #',
      name: 'part_number',
      colIndex: 8,
      hidden: false,
      width: 60,
    },
    {
      prefSeqId: 181,
      colName: 'KANBAN #',
      name: 'kanban_number',
      colIndex: 8,
      hidden: false,
      width: 60,
    },
    {
      prefSeqId: 181,
      colName: 'ETA',
      name: 'eta',
      colIndex: 9,
      hidden: false,
      width: 60,
    },
    {
      prefSeqId: 181,
      colName: 'STATUS',
      name: 'status',
      colIndex: 10,
      hidden: false,
      width: 60,
    },

    {
      prefSeqId: 181,
      colName: 'NEXT CONNECTION',
      name: 'next_connection',
      colIndex: 11,
      hidden: false,
      width: 60,
    },
    {
      prefSeqId: 181,
      colName: 'LAST UPDATE',
      name: 'last_updated',
      colIndex: 12,
      hidden: false,
      width: 60,
    },
  ];
}
